import type { GraphQLError } from 'graphql';
import parseGraphQLError from '../../utils/error/parseGraphQLError';
import Logger from '../../utils/Logger';

const getErrorMessage = (
  error: { graphQLErrors: readonly GraphQLError[] } | null | undefined,
  entity: string,
) => {
  const errorCode = error?.graphQLErrors?.[0]
    ? parseGraphQLError(error.graphQLErrors[0]).code
    : null;

  if (!errorCode) {
    return null;
  }

  const messages = {
    TOKEN_INVALID: `We could not validate the ${entity}.`,
    TOKEN_REUSE: `It seems like this ${entity} has been used.`,
    TOKEN_OLD: `A newer ${entity} was requested.`,
    TOKEN_EXPIRED: `This ${entity} has expired.`,
  };

  const message = messages[errorCode as keyof typeof messages];

  if (message) return message;

  Logger.warn(`Unknown error code for showing message: ${errorCode}`);
  return 'Something went wrong.';
};

export default getErrorMessage;
